import Vue from "vue";

export default {
  getLeaveTypes({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("tableLoader", true);

      const params = {
        page: state.currentPage,
        perPage: state.perPage,
        ...(state.searchQuery != "" && { search_query: state.searchQuery }),
      };

      Vue.$http
        .get("/hrm/leaves/settings/leavetypes", { params })
        .then(response => {
          commit("leaveTypes", response.data.results);
          commit("leaveTypeTotal", response.data.total);
          commit("tableLoader", false);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoader", false);
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  handleSizeChange({ commit, dispatch }, perPage) {
    commit("perPage", perPage);
    commit("currentPage", 1);
    dispatch("getAllLeaves");
  },
  handleCurrentChange({ commit, dispatch }, page) {
    commit("currentPage", page);
    dispatch("getAllLeaves");
  },
  handleSizeChangeType({ commit, dispatch }, perPage) {
    commit("perPage", perPage);
    commit("currentPage", 1);
    dispatch("getLeaveTypes");
  },
  handleCurrentChangeType({ commit, dispatch }, page) {
    commit("currentPage", page);
    dispatch("getLeaveTypes");
  },
  handleSizeChangeApproval({ commit, dispatch }, perPage) {
    commit("perPage", perPage);
    commit("currentPage", 1);
    dispatch("searchLeaveApprovers");
  },
  handleCurrentChangeApproval({ commit, dispatch }, page) {
    commit("currentPage", page);
    dispatch("getLeaveTypes");
    dispatch("searchLeaveApprovers");
  },
  createLeaveType(_, data) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post("/hrm/leaves/settings/leavetypes", data)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  updateLeaveType(_, { data, id }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`/hrm/leaves/settings/leavetypes/${id}`, data)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getLeaveTypeById(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/hrm/leaves/settings/leavetypes/${id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getBranches({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get("/organization/branches")
        .then(response => {
          commit("branches", response.data.results);
          resolve(response.data.results);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  getLeaveType({ commit }, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`hrm/leaves/settings/leavetypes/${id}`)
        .then(response => {
          commit("currentLeaveType", response.data);
          resolve(response);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  deleteLeaveType(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete(`/hrm/leaves/settings/leavetypes/${id}`)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  searchLeaveApprovers({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("tableLoader", true);

      const params = {
        page: state.currentPage,
        perPage: state.perPage,
        ...(state.searchQuery != "" && { search_query: state.searchQuery }),
      };

      Vue.$http
        .get("/hrm/leaves/settings/approversettings", { params })
        .then(response => {
          commit("leaveApprovers", response.data.results);
          commit("totalLeaveApprover", response.data.total);
          commit("tableLoader", false);
          resolve(response.data);
        })
        .catch(error => {
          commit("tableLoader", false);
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  getLeaveApproverById({ commit }, id) {
    commit("viewContainerLoading", true);
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`hrm/leaves/settings/approversettings/${id}`)
        .then(response => {
          commit("currentLeaveApprover", response.data);
          commit("viewContainerLoading", false);
          commit("employees", response.data.employees);
          resolve(response);
        })
        .catch(error => {
          commit("viewContainerLoading", false);
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  deleteLeaveApprover(_, id) {
    const ids = [id];
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/hrm/leaves/settings/approversettings/delete`, {
          approverIds: ids,
        })
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getEmployeeGrades({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get("/organization/employees/settings/grades")
        .then(response => {
          commit("employeeGrades", response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getDepartments({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get("organization/departments")
        .then(response => {
          commit("departments", response.data);
          resolve(response.data.results);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  createLeaveApprover(_, data) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post("/hrm/leaves/settings/approversettings", data)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  updateLeaveApprover(_, { data, id }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`/hrm/leaves/settings/approversettings/${id}`, data)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  createLeave(_, data) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post("/hrm/leaves", data)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  updateLeave(_, { data, id }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`/hrm/leaves/${id}`, data)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllLeaves({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("tableLoader", true);

      const params = {
        page: state.currentPage,
        perPage: state.perPage,
        ...(state.searchQuery != "" && { search_query: state.searchQuery }),
        ...(state.filterValue != "" && { status: state.filterValue }),
        ...(state.filterDate != null && { start_date: state.filterDate[0] }),
        ...(state.filterDate != null && { end_date: state.filterDate[1] }),
        ...(state.filterLeaveTypes != "" && {
          leave_type_id: state.filterLeaveTypes,
        }),
      };
      Vue.$http
        .get("/hrm/leaves", { params })
        .then(response => {
          commit("leavesData", response.data.results);
          commit("leaveTotal", response.data.total);
          commit("tableLoader", false);
          resolve(response.data);
        })
        .catch(error => {
          commit("tableLoader", false);
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  getLeaveById({ commit }, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`hrm/leaves/${id}`)
        .then(response => {
          commit("currentLeave", response.data);
          resolve(response);
        })
        .catch(error => {
          Vue.$notification("error", error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  getLeaveByEmployee({ commit, state }, id) {
    commit("employeeLeaveEmployeeId", id);
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`hrm/leave-types-by-employee?employee_id=${id}`)
        .then(response => {
          if (state.employeeLeaveEmployeeId === id) {
            commit("employeeLeave", response.data);
          }
          resolve(response);
        })
        .catch(error => {
          Vue.$notification("error", error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  deleteLeaves(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/hrm/leaves/delete`, { leave_ids: id })
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  approveLeavesStatus(_, { ids, endpoint }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`hrm/leaves/${endpoint}`, { leave_request_ids: ids })
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  rejectLeavesStatus(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`hrm/leaves/reject/${id}`)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  cancelLeaves(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`hrm/leaves/cancel/${payload.id}`, {
          cancellation_reason: payload.cancellation_reason,
        })
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchLeaveTypes({ commit }) {
    return new Promise((resolve, reject) => {
      commit("tableLoader", true);

      Vue.$http
        .get("/hrm/leaves/settings/leavetypes")
        .then(response => {
          const leaveTypes = Array.isArray(response.data)
            ? response.data
            : (response.data && response.data.results) || [];
          commit("leaveTypesSearch", leaveTypes);
          commit("tableLoader", false);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoader", false);
          Vue.$notification("error", error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
};
